import React from "react";
import { LuMinus, LuPlus, LuTrash2 } from "react-icons/lu";
import { cn } from "./cn";

interface QtyStepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  /** Com onRemove, o "−" no mínimo vira lixeira em vez de travar. */
  onRemove?: () => void;
  /** Nome do item, para os leitores de tela ("Diminuir quantidade de Placa…"). */
  label: string;
}

const STEP = "grid h-10 w-10 place-items-center rounded-full bg-surface text-primary shadow-card transition-colors hover:bg-primary-soft focus-visible:outline-none focus-visible:shadow-focus disabled:cursor-not-allowed disabled:opacity-40";

export const QtyStepper: React.FC<QtyStepperProps> = ({ value, onChange, min = 1, max = 99, onRemove, label }) => {
  const atMin = value <= min;
  const removes = atMin && !!onRemove;

  return (
    <div className="inline-flex shrink-0 items-center gap-0.5 rounded-button bg-primary-tint p-0.5">
      <button
        type="button"
        className={cn(STEP, removes && "text-danger")}
        onClick={removes ? onRemove : () => onChange(value - 1)}
        disabled={atMin && !onRemove}
        aria-label={removes ? `Remover ${label}` : `Diminuir quantidade de ${label}`}
      >
        {removes ? <LuTrash2 size={16} aria-hidden /> : <LuMinus size={16} aria-hidden />}
      </button>
      <span className="min-w-7 text-center font-bold tabular-nums text-primary" aria-live="polite">
        {value}
      </span>
      <button
        type="button"
        className={STEP}
        onClick={() => onChange(value + 1)}
        disabled={value >= max}
        aria-label={`Aumentar quantidade de ${label}`}
      >
        <LuPlus size={16} aria-hidden />
      </button>
    </div>
  );
};
